const mvEcomServicesData = [
  {
    title: "Multi-Vendor Marketplace Development",
    description:
      "Build powerful, scalable multi-vendor platforms where multiple sellers can register, list products, and manage sales seamlessly — all under one robust admin system.",
    bullets: [
      "Custom marketplace architecture (B2B / B2C / C2C)",
      "Vendor storefronts with branding options",
      "Centralized admin controls & analytics",
      "Secure, high-performance backend",
    ],
    minHeight: 420,
  },
  {
    title: "Vendor Onboarding & Management System",
    description:
      "Simplify vendor registration, verification, and catalog management with automated workflows and an intuitive vendor dashboard.",
    bullets: [
      "Easy registration & KYC verification",
      "Tiered commission configuration",
      "Real-time order and payout tracking",
      "Vendor rating & review engine",
    ],
    minHeight: 420,
  },
  {
    title: "Payment Gateway & Commission Management",
    description:
      "Ensure seamless, transparent transactions between vendors and customers with automated commission splits and multi-currency support.",
    bullets: [
      "Razorpay, Stripe, PayPal integrations",
      "Automated payout system",
      "Multi-currency & tax compliance",
      "Refund & dispute management",
    ],
    minHeight: 420,
  },
  {
    title: "Inventory, Order & Logistics Integration",
    description:
      "Integrate live inventory management, order tracking, and delivery APIs for real-time visibility and efficiency.",
    bullets: [
      "Stock synchronization across vendors",
      "Order & shipment tracking",
      "Integration with Shiprocket / Delhivery",
      "Automated alerts & notifications",
    ],
    minHeight: 420,
  },
  {
    title: "Mobile App for Vendors & Customers",
    description:
      "Deliver smooth buying and selling experiences with dedicated mobile apps for both vendors and customers, fully synced with your web platform.",
    bullets: [
      "Vendor app for catalog & order management",
      "Customer app with modern UI/UX",
      "Push notifications & live tracking",
      "Cross-platform (iOS & Android) support",
    ],
    minHeight: 420,
  },
  {
    title: "Admin Dashboard & Analytics",
    description:
      "Gain full control over marketplace operations with a real-time admin panel and advanced analytics for insights and performance tracking.",
    bullets: [
      "Sales & vendor performance dashboards",
      "Automated reporting & insights",
      "Role-based access control",
      "AI-driven business recommendations",
    ],
    minHeight: 420,
  },
];

export default mvEcomServicesData;
